<template>
    <div> 
        <v-simple-table
            class="bordered-table"
        >
            
            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td colspan="4" class="font-weight-bold text-h6">Dados principais</td>
                </tr>
                <tr>
                    <td><span class="font-weight-bold"> Código:</span> 
                        <v-chip
                            color="primary"
                            class="ml-2 font-weight-bold"
                        >
                            {{ object.codigo }}
                        </v-chip>  
                    </td>
                    <td>
                        <span class="font-weight-bold">Status:</span> 
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                    <v-chip
                                        class="ml-2 font-weight-bold"
                                        :color="object.status | statusProperty"
                                    >
                                        {{ object.status }}
                                    </v-chip> 
                                </span>
                            </template>
                            <span v-if="object.obs_status && object.obs_status != null">{{ object.obs_status }}</span>
                        </v-tooltip>
                    </td>
                    <td><span class="font-weight-bold">Data Cadastro:</span> {{ object.created_at }} </td>
                    <td><span class="font-weight-bold">Data Atualização:</span> {{ object.data_atualizacao }} </td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="4" class="font-weight-bold text-subtitle-1">Dados principais</td>
                </tr>
                <tr>
                    <td colspan="2"><span class="font-weight-bold"> Código:</span> 
                        <div>
                            <v-chip
                                color="primary"
                                class="ml-2 font-weight-bold"
                            >
                                {{ object.codigo }}
                            </v-chip>  
                        </div>
                    </td>
                    <td colspan="2">
                        <span class="font-weight-bold">Status:</span> 
                        <div>
                        <v-chip
                            class="ml-2 font-weight-bold"
                            :color="object.status | statusProperty"
                        >
                            {{ object.status }}
                        </v-chip> 
                        </div> 
                    </td>
                </tr>
                <tr>    
                    <td colspan="2"><span class="font-weight-bold">Data Cadastro:</span> <div> {{ object.created_at }} </div></td>
                    <td colspan="2"><span class="font-weight-bold">Data Atualização:</span> <div> {{ object.data_atualizacao }} </div> </td>
                </tr>
            </template>
            
        </v-simple-table>  



        <v-simple-table
            class="bordered-table mt-2"
        >
             <tr>
                <td colspan="4">
                    <span class="font-weight-bold">Endereço:</span> 
                    {{ fullAddress(object) }}
                </td>
            </tr>

            <tr>
                <td colspan="4">
                    <span class="font-weight-bold">Titulo:</span> 
                    {{ object.titulo_publicitario }}
                </td>
            </tr>
           
            <tr>
                <td colspan="4">
                    <span class="font-weight-bold">Endereço publicidade:</span> 
                    {{ fullCommercialAddress(object) }}
                </td>
            </tr>

            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td colspan="3">
                        <span class="font-weight-bold">Locais (bairro publicidade):</span>
                        <span v-if="object.places && object.places.length > 0">
                            <v-chip
                                color="#FFE99E"
                                class="ma-1"
                                v-for="lc in object.places" :key="lc.id"    
                            >
                                {{ lc.distrito }} - {{ lc.cidade }}
                            </v-chip>
                        </span>
                    </td>
                    <td><span class="font-weight-bold">Setor:</span> {{ object.setor }} </td>
                </tr>
            </template>
            <template v-else>
                <tr>    
                    <td colspan="4"><span class="font-weight-bold">Setor:</span> {{ object.setor }} </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold">Locais (bairro publicidade):</span>
                        <span v-if="object.places && object.places.length > 0">
                            <v-chip
                                color="#FFE99E"
                                class="ma-1"
                                v-for="lc in object.places" :key="lc.id"    
                            >
                                {{ lc.distrito }} - {{ lc.cidade }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
            </template>


            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td><span class="font-weight-bold">Finalidade:</span> {{ object.finalidade }} </td>
                    <td><span class="font-weight-bold">Estado do imóvel:</span> {{ object.estado_imovel }} </td>
                    <td><span class="font-weight-bold">Região:</span> {{ object.regiao }} </td>
                    <td>
                        <span class="font-weight-bold">Construtora:</span>  
                        <span v-if="object.builder && object.builder.nome != ''">
                            {{ object.builder.nome }}
                        </span>
                    </td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="4"><span class="font-weight-bold">Finalidade:</span> {{ object.finalidade }} </td>
                </tr>
                <tr>    
                    <td colspan="4"><span class="font-weight-bold">Estado do imóvel:</span> {{ object.estado_imovel }} </td>
                </tr>
                <tr>     
                    <td colspan="4"><span class="font-weight-bold">Região:</span> {{ object.regiao }} </td>
                </tr>
                <tr>                    
                    <td colspan="4">
                        <span class="font-weight-bold">Construtora:</span>  
                        <span v-if="object.builder && object.builder.nome != ''">
                            {{ object.builder.nome }}
                        </span>
                    </td>    
                </tr>
            </template>

            <tr>
                <td colspan="4">
                    <span class="font-weight-bold">Perto de:</span> 
                    <span v-if="object.perto_de && object.perto_de.length > 0">
                        {{ object.perto_de | convertArrayToString }}
                    </span>
                </td>
            </tr>

            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td colspan="2">
                        <span class="font-weight-bold">Placa:</span>
                        <span v-if="object.boards && object.boards.length > 0">
                            <span class="mr-4">{{ object.boards[0].data_placa }}</span>
                            <span class="mr-4">{{ object.boards[0].user }}</span>
                            <span class="mr-4">{{ object.boards[0].obs }}</span>
                        </span>  
                    </td>
                    <td colspan="2">
                        <span class="font-weight-bold">Vídeos:</span>
                        <span v-if="object.videos && object.videos.length > 0">
                            <v-chip
                                class="ma-1"
                                v-for="inf in object.videos" :key="inf.id"    
                            >
                                <a v-if="inf.type == 'YouTube'" :href="inf.description | urlYoutube" download target="_blank">  
                                <span style="color: #000;">  {{ inf.type }} - {{ inf.description }}  </span>                      
                                </a>
                                <a v-else :href="inf.description" download target="_blank">  
                                <span style="color: #000;">  {{ inf.type }} - {{ inf.description }} </span>                       
                                </a>
                            </v-chip>
                        </span>
                    </td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold">Placa:</span>
                        <span v-if="object.boards && object.boards.length > 0">
                            <span class="mr-4">{{ object.boards[0].data_placa }}</span>
                            <span class="mr-4">{{ object.boards[0].user }}</span>
                            <span class="mr-4">{{ object.boards[0].obs }}</span>
                        </span>  
                    </td>
                </tr>
                <tr>    
                    <td colspan="4">
                        <span class="font-weight-bold">Vídeos:</span>
                        <span v-if="object.videos && object.videos.length > 0">
                            <v-chip
                                class="ma-1"
                                v-for="inf in object.videos" :key="inf.id"    
                            >
                                <a v-if="inf.type == 'YouTube'" :href="inf.description | urlYoutube" download target="_blank">  
                                <span style="color: #000;">  {{ inf.type }} - {{ inf.description }}  </span>                      
                                </a>
                                <a v-else :href="inf.description" download target="_blank">  
                                <span style="color: #000;">  {{ inf.type }} - {{ inf.description }} </span>                       
                                </a>
                            </v-chip>
                        </span>
                    </td>
                </tr>
            </template>

            <tr>
                <td colspan="4">
                    <span class="font-weight-bold">Portais:</span>
                    <span v-if="object.portals && object.portals.length > 0">
                        <v-chip
                            color="#E7E1FA"
                            class="ma-1"
                            v-for="inf in object.portals" :key="inf.id"    
                        >
                        <span v-if="inf.portal_item">{{ inf.portal_item.nome }}</span>
                        <span class="ml-2" v-if="inf.modelo"> ({{ inf.modelo }})</span>
                        </v-chip>
                    </span>
                </td>
            </tr>
        </v-simple-table>

        <v-simple-table class="bordered-table mt-2">

            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td><span class="font-weight-bold">Valor venda:</span> <span class="text-h6"> {{ object.valor_venda | toCurrency }} </span> </td>
                    <td><span class="font-weight-bold">Valor locação:</span> <span class="text-h6"> {{ object.valor_locacao | toCurrency }} </span> </td>
                    <td><span class="font-weight-bold">Valor condomínio:</span> {{ object.valor_condominio | toCurrency }} </td>
                    <td><span class="font-weight-bold">Valor IPTU:</span> {{ object.valor_iptu | toCurrency }} </td>
                </tr>
                <tr>
                <td><span class="font-weight-bold"> Valor temporada:</span> {{ object.valor_temporada | toCurrency }} </td> 
                <td><span class="font-weight-bold"> Valor avaliaçāo:</span> {{ object.valor_avaliacao | toCurrency }} </td> 
                <td><span class="font-weight-bold"> Valor seguro fiança:</span> {{ object.valor_seguro_fianca | toCurrency }} </td>  
                <td><span class="font-weight-bold"> Valor seguro incêndio:</span> {{ object.valor_seguro_incendio | toCurrency }} </td> 
                </tr>

                <tr>
                    <td>
                        <span class="font-weight-bold"> Dormitório(s):</span> <span class="text-h6">{{ object.dormitorios }} </span>
                    </td>
                    <td>
                        <span class="font-weight-bold"> Suíte(s):</span> <span class="text-h6">{{ object.suites }}</span> 
                    </td>
                    <td>
                        <span class="font-weight-bold"> Banheiro(s):</span> <span class="text-h6">{{ object.banheiros }}</span> 
                    </td>
                    <td>
                        <span class="font-weight-bold"> Vaga(s):</span> <span class="text-h6">{{ object.vagas }}</span> 
                    </td>
                </tr>

                <tr>
                    <td><span class="font-weight-bold">{{ object.tipo_imovel | labelArea('area') }}:</span> <span class="text-h6">{{ object.area }}</span> m²</td>
                    <td v-if="object.tipo_imovel != 'Área' && object.tipo_imovel != 'Terreno'">
                        <span class="font-weight-bold">{{ object.tipo_imovel | labelArea('area_total') }}: </span> 
                        {{ object.area_total }} m²
                    </td>
                    <td><span class="font-weight-bold"> Frente:</span> {{ object.frente }} m</td>
                    <td><span class="font-weight-bold"> Fundo:</span> {{ object.frente }} m</td> 
                </tr>
                <tr>  
                    <td><span class="font-weight-bold"> Lado direito:</span> {{ object.lado_direito }} m</td> 
                    <td><span class="font-weight-bold"> Lado esquerdo:</span> {{ object.lado_esquerdo }} m</td>              
                    <td>
                        <span class="font-weight-bold"> Á. const. no terreno:</span>
                        {{ object.area_construida_terreno }} m²
                    </td>
                    <td><span class="font-weight-bold"> Para renda:</span> {{ object.para_renda }}</td> 
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="2"><span class="font-weight-bold">Valor venda:</span> <div> {{ object.valor_venda | toCurrency }} &nbsp;</div></td>
                    <td colspan="2"><span class="font-weight-bold">Valor locação:</span> <div> {{ object.valor_locação | toCurrency }} &nbsp; </div></td>
                </tr> 
                <tr>
                    <td colspan="2"><span class="font-weight-bold">Valor condomínio:</span> <div> {{ object.valor_condominio | toCurrency }} &nbsp;</div></td>
                    <td colspan="2"><span class="font-weight-bold">Valor IPTU:</span> <div>{{ object.valor_iptu | toCurrency }} &nbsp;</div> </td>
                </tr>
                <tr>
                    <td colspan="2"><span class="font-weight-bold"> Valor temporada:</span> <div> {{ object.valor_temporada | toCurrency }} &nbsp; </div> </td> 
                    <td colspan="2"><span class="font-weight-bold"> Valor avaliaçāo:</span> <div> {{ object.valor_avaliacao | toCurrency }} &nbsp; </div></td> 
                </tr>
                <tr>
                    <td colspan="2"><span class="font-weight-bold"> Vl. seg. fiança:</span> <div> {{ object.valor_seguro_fianca | toCurrency }} &nbsp; </div></td>  
                    <td colspan="2"><span class="font-weight-bold"> Vl. seg. incêndio:</span> <div> {{ object.valor_seguro_incendio | toCurrency }} &nbsp; </div></td> 
                </tr>
                <tr>
                    <td colspan="2">
                        <span class="font-weight-bold"> Dormitório(s):</span> <div> {{ object.dormitorios }} &nbsp;</div>
                    </td>
                    <td colspan="2">
                        <span class="font-weight-bold"> Suíte(s):</span> <div> {{ object.suites }} &nbsp;</div> 
                    </td>
                </tr>
                <tr>    
                    <td colspan="2">
                        <span class="font-weight-bold"> Banheiro(s):</span> <div> {{ object.banheiros }} &nbsp;</div>
                    </td>
                    <td colspan="2">
                        <span class="font-weight-bold"> Vaga(s):</span> <div> {{ object.vagas }} &nbsp;</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2"><span class="font-weight-bold">{{ object.tipo_imovel | labelArea('area') }}:</span> <div>{{ object.area }} m² </div></td>
                    <td colspan="2" v-if="object.tipo_imovel != 'Área' && object.tipo_imovel != 'Terreno'">
                        <span class="font-weight-bold">{{ object.tipo_imovel | labelArea('area_total') }}: </span> 
                        <div>{{ object.area_total }} m² </div>
                    </td>
                </tr>
                <tr>    
                    <td colspan="2"><span class="font-weight-bold"> Frente:</span>  <div> {{ object.frente }} m </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Fundo:</span> <div> {{ object.frente }} m </div></td> 
                </tr>
                <tr>  
                    <td colspan="2"><span class="font-weight-bold"> Lado direito:</span> <div> {{ object.lado_direito }} m </div></td> 
                    <td colspan="2"><span class="font-weight-bold"> Lado esquerdo:</span> <div> {{ object.lado_esquerdo }} m </div></td>              
                </tr>
                <tr>    
                    <td colspan="2">
                        <span class="font-weight-bold"> Á. const. no terreno:</span>
                        <div>
                        {{ object.area_construida_terreno }} m²
                        </div>
                    </td>
                    <td><span class="font-weight-bold"> Para renda:</span> 
                        <div>
                        {{ object.para_renda }}
                        </div>
                    </td>
                </tr>
            </template>     
        </v-simple-table>

        <v-simple-table class="bordered-table mt-2">
            <template v-if="!$vuetify.breakpoint.smAndDown">
                <tr>
                    <td><span class="font-weight-bold"> Ocupação:</span> {{ object.imovel_ocupado }}</td>
                    <td><span class="font-weight-bold"> Aceita permuta?</span>
                     {{ object.aceita_permuta }}

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-chip
                                    class="ml-2 font-weight-bold"   
                                    color="#E7E1FA"
                                >
                                    Detalhes
                                </v-chip> 
                            </span>
                        </template>
                        
                        <div>
                            <div v-if="object.tipo_permuta && object.tipo_permuta.length > 0 && object.tipo_permuta != '[]'">
                                <span v-for="tp in object.tipo_permuta" :key="tp" class="">
                                    {{ tp }}
                                    <span v-if="(index + 1) < object.tipo_permuta.length">, </span>
                                </span>
                            </div>
                            <div v-if="object.obs_permuta">
                                {{ object.obs_permuta }}
                            </div>
                        </div>
                        
                    </v-tooltip>

                    </td>
                    <td><span class="font-weight-bold"> Aceita financiamento?</span> {{ object.aceita_financiamento }}</td>
                    <td><span class="font-weight-bold"> Recaptaçāo: </span> {{ object.imovel_recaptado }}</td>
                </tr>
                <tr>                
                    <td><span class="font-weight-bold"> Topografia: </span> {{ object.topografia }}</td>
                    <td><span class="font-weight-bold"> Ano construçāo: </span> {{ object.ano_construcao }}</td>
                    <td><span class="font-weight-bold"> Data entrega: </span> {{ object.data_entrega }}</td>
                    <td><span class="font-weight-bold"> Venc. contrato: </span> {{ object.vencimento_contrato_locacao }}</td>
                </tr>
                <tr>                
                    <td><span class="font-weight-bold"> Comissão Locaçāo: </span> {{ object.comissao_primeiro_aluguel }} %</td>
                    <td><span class="font-weight-bold"> Taxa ADM: </span> {{ object.taxa_adm }} %</td>
                    <td><span class="font-weight-bold"> Contrato locaçāo: </span> {{ object.data_entrega }}</td>
                    <td><span class="font-weight-bold"> Documentaçāo: </span> {{ object.vencimento_contrato_locacao }}</td>
                </tr>
                <tr>                
                    <td colspan="4"><span class="font-weight-bold"> Garantias aceitas: </span> {{ object.garantia_locacao | convertArrayToString }}</td>
                </tr>
                <tr>                
                    <td colspan="4"><span class="font-weight-bold"> Observações: </span> {{ object.observacoes }}</td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Área privativa: </span>
                        <span v-if="object.private_areas && object.private_areas.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.private_areas" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Infraestrutura: </span>
                        <span v-if="object.infrastructures && object.infrastructures.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.infrastructures" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Área de lazer: </span>
                        <span v-if="object.recreations && object.recreations.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.recreations" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
            </template> 
            <template v-else>
                <tr>
                    <td colspan="2"><span class="font-weight-bold"> Ocupação:</span> <div> {{ object.imovel_ocupado }} &nbsp; </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Aceita permuta?</span> <div> {{ object.aceita_permuta }} &nbsp; </div></td>
                </tr>
                <tr>    
                    <td colspan="2"><span class="font-weight-bold"> Aceita financiamento?</span> <div> {{ object.aceita_financiamento }}&nbsp; </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Recaptaçāo: </span> <div>{{ object.imovel_recaptado }}&nbsp; </div></td>
                </tr>
                <tr>                
                    <td colspan="2"><span class="font-weight-bold"> Topografia: </span> <div>{{ object.topografia }}&nbsp; </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Ano construçāo: </span> <div>{{ object.ano_construcao }}&nbsp; </div></td>
                </tr>
                <tr>    
                    <td colspan="2"><span class="font-weight-bold"> Data entrega: </span> <div>{{ object.data_entrega }}&nbsp; </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Venc. contrato: </span> <div>{{ object.vencimento_contrato_locacao }}&nbsp; </div></td>
                </tr>
                <tr>                
                    <td colspan="2"><span class="font-weight-bold"> Comissão Locaçāo: </span> <div>{{ object.comissao_primeiro_aluguel }} %</div></td>
                    <td colspan="2"><span class="font-weight-bold"> Taxa ADM: </span> <div>{{ object.taxa_adm }} %</div></td>
                </tr>
                <tr>    
                    <td colspan="2"><span class="font-weight-bold"> Contrato locaçāo: </span> <div>{{ object.data_entrega }}&nbsp; </div></td>
                    <td colspan="2"><span class="font-weight-bold"> Documentaçāo: </span> <div>{{ object.vencimento_contrato_locacao }}&nbsp; </div></td>
                </tr>
                <tr>                
                    <td colspan="4"><span class="font-weight-bold"> Garantias aceitas: </span> <div>{{ object.garantia_locacao | convertArrayToString }}&nbsp; </div></td>
                </tr>
                <tr>                
                    <td colspan="4"><span class="font-weight-bold"> Observações: </span> <div>{{ object.observacoes }}&nbsp; </div></td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Área privativa: </span>
                        <span v-if="object.private_areas && object.private_areas.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.private_areas" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Infraestrutura: </span>
                        <span v-if="object.infrastructures && object.infrastructures.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.infrastructures" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span class="font-weight-bold"> Área de lazer: </span>
                        <span v-if="object.recreations && object.recreations.length > 0">
                            <v-chip
                                color="#A9FCB6"
                                class="ma-1"
                                v-for="inf in object.recreations" :key="inf.id"    
                            >
                                {{ inf.description }}
                            </v-chip>
                        </span>
                    </td>
                </tr>
            </template>   
        </v-simple-table>

        <v-simple-table
            class="bordered-table mt-2"
        >
            <tr>
                <td colspan="4" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-bold text-subtitle-1' : 'font-weight-bold text-h6'">Dados colaboradores</td>
            </tr>
            <tr v-if="object.colaborators && object.colaborators.length > 0">
                <td>
                    <span v-for="item in object.colaborators" :key="item.id">
                        <span class="mr-4">
                            <span>{{ item.name }}</span>
                            <span v-if="item.description"> ({{ item.description }})</span>
                        </span>
                    </span>
                </td>
            </tr>
        </v-simple-table>

        <v-expansion-panels class="mt-2 " flat tile style="border: 1px solid #ddd;">
            <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate class="ma-0 pa-2">
                    <span :class="$vuetify.breakpoint.smAndDown ? 'font-weight-bold text-subtitle-1' : 'font-weight-bold text-h6'">Dados do proprietário</span>

                    <template v-slot:actions>
                        <span class="pa-2">Clique para visualizar</span>
                        <v-icon color="pink">
                            mdi-eye
                        </v-icon>
                    </template>
                
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div
                        v-if="!can('Acesso aos proprietarios de outras carteiras', { item: item })"
                    >
                        <v-alert
                            type="error"
                        >
                            Voce não possui permissão para acessar os dados do proprietário desse imóvel.
                        </v-alert>
                    </div>

                    <v-simple-table
                        v-else
                        class="bordered-table mt-2"
                    >
                        <tr>
                            <td><span class="font-weight-bold"> Chaves: </span> 
                                    {{ object.chaves }}
                                    <span v-if="object.obs_chaves"> ({{ object.obs_chaves }})</span>
                            </td> 
                        </tr>
                        <tr>
                            <td>

                                <template v-if="!$vuetify.breakpoint.smAndDown"> 
                                    <v-simple-table>
                                        <tr>
                                            <td class="text-left font-weight-bold">
                                                Nome
                                            </td>
                                            <td class="text-left font-weight-bold">
                                                Telefone
                                            </td>
                                            <td class="text-left font-weight-bold">
                                                E-mail
                                            </td>
                                            <td class="text-left font-weight-bold">
                                                Obs
                                            </td>
                                        </tr>
                                        <tr v-for="owner in object.property_owners" :key="owner.id">
                                            <td>{{ owner.nome }}</td>
                                            <td>
                                                <phone-component v-if="owner.telefone" :object="owner.telefone"></phone-component> 
                                                <phone-component v-if="owner.telefone2" :object="owner.telefone2"></phone-component>
                                            </td>
                                            <td>
                                                {{ owner.email }}
                                            </td>
                                            <td>
                                                {{ owner.obs }}
                                            </td>
                                        </tr>
                                    </v-simple-table>
                                </template>

                                <template v-else> 
                                    <v-simple-table>
                                        <span  v-for="owner in object.property_owners" :key="owner.id">
                                            <tr>
                                                <td class="text-left">
                                                    <span class="font-weight-bold">Nome:</span> 
                                                    <div>
                                                        {{ owner.nome }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-left">
                                                    <span class="font-weight-bold">Telefone:</span> 
                                                    <div>
                                                        <phone-component v-if="owner.telefone" :object="owner.telefone"></phone-component> 
                                                        <phone-component v-if="owner.telefone2" :object="owner.telefone2"></phone-component>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>    
                                                <td class="text-left">
                                                    <span class="font-weight-bold">E-mail:</span> 
                                                    <div>
                                                        {{ owner.email }}
                                                    </div>                                                        
                                                </td>
                                            </tr>
                                            <tr>                                                
                                                <td class="text-left">
                                                    <span class="font-weight-bold">Obs:</span> 
                                                    <div>
                                                        {{ owner.obs }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </span>
                                    </v-simple-table>
                                </template>

                            </td>
                        </tr>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>  
        </v-expansion-panels> 

        <v-expansion-panels class="mt-2 " flat tile style="border: 1px solid #ddd;">
            <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate class="ma-0 pa-2">
                    <span :class="$vuetify.breakpoint.smAndDown ? 'font-weight-bold text-subtitle-1' : 'font-weight-bold text-h6'">Texto Publicitário</span>
                <template v-slot:actions>
                    <span class="pa-2">Clique para visualizar</span>
                    <v-icon color="pink">
                        mdi-eye
                    </v-icon>
                </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    {{ object.texto_publicitario }}
                </v-expansion-panel-content>
            </v-expansion-panel>  
        </v-expansion-panels> 

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PhoneComponent from '@/components/phone/PhoneComponent.vue';

export default {
    components: {
        PhoneComponent
    },

    props: {
        object: {
            type: Object, 
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    computed: {
        ...mapGetters('permissions', ['can']),

        hasData() {
            return this.object && Object.keys(this.object).length > 0;
        }       
    }, 

    data () {
        return {
            item: {},
            headers: {
                owners: [
                    { text: 'NOME', align: 'start', value: 'nome', },
                    { text: 'TELEFONE', value: 'telefone' },
                    { text: 'EMAIL', value: 'email' }
                ],
            }    
        }
    },
}
</script>

<style scoped>
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.bordered-table th {
  background-color: #f5f5f5;
}
</style>